import { ALLOWED_COUNTRIES, DEVICES } from "@adlywise/shared-data";
import type { ChoiceOption } from "./types";

export const DRAWER_TRANSITION_MS = 220;

export const COUNTRY_OPTIONS: ChoiceOption<string>[] = Array.from(
  ALLOWED_COUNTRIES.entries(),
)
  .map(([code, name]) => ({
    value: code,
    label: name,
  }))
  .sort((left, right) => left.label.localeCompare(right.label));

export const DEVICE_OPTIONS: ChoiceOption<number>[] = Array.from(
  DEVICES.entries(),
)
  .map(([label, value]) => ({
    value,
    label,
  }))
  .sort((left, right) => left.label.localeCompare(right.label));

export const KIND_OPTIONS: ChoiceOption<number>[] = [
  { value: 0, label: "Dynamic" },
  { value: 1, label: "Overlay" },
  { value: 2, label: "Banner" },
  { value: 3, label: "Static" },
];
